// ─── SOCIAL CHANNELS ────────────────────────────────────────────────────────
// Pipeline-only token/temp maps and behavior flags removed.
//
// This array drives the channel picker in "Tipo di contenuto"
// (Step1Setup.jsx). It is the list of channels a user can SELECT — not the
// list the app can RENDER.
//
// Pinterest and YouTube were retired from the picker (issue #32). Runs already
// in Storico Generazioni still render: the one renderer (outputs/
// PiecesResultEntry.jsx) draws every format from its piece list
// (publish/pieces/pinterestPost.js, youtubePost.js) and copies / downloads
// through publish/downloads.js, none of which reads this array.
export const SOCIAL_CHANNELS = [
  { id: 'instagram', name: 'Instagram', color: '#E4405F',
    maxChars: 2200, hashtagPolicy: '20-30 hashtag (nel primo commento)', emojiPolicy: 'Frequente e naturale',
    description: 'Caption visuale per Instagram — emozionale, hashtag strategy, CTA engagement' },
  { id: 'facebook', name: 'Facebook', color: '#1877F2',
    maxChars: 2000, hashtagPolicy: '0-2 hashtag', emojiPolicy: 'Naturale e caldo',
    description: 'Post conversazionale per feed Facebook — storytelling, community, condivisibilità' },
];

// ─── EMAIL CHANNELS ──────────────────────────────────────────────────────────

export const EMAIL_CHANNELS = [
  {
    id: 'email-classic',
    name: 'Email',
    color: '#EC4899',
    iconId: 'mail',
    description: 'Newsletter email classica: subject line + corpo + CTA',
  },
  {
    id: 'linkedin-newsletter',
    name: 'LinkedIn',
    color: '#0A66C2',
    iconId: 'book-open',
    description: 'Articolo LinkedIn Newsletter: titolo + sezioni H2 + companion post',
  },
];

